import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./data/hooks/theme/useTheme";

// Service worker (de)registration is handled by ServiceWorkerManager, which
// only registers it on the order picking routes it's actually needed for.
// See ./serviceWorker.js for details.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>,
);
